import { createSelector } from '@reduxjs/toolkit'
import type { Workspace } from '@store/reducers/dashboard/types'

import { selectWorkspaceId } from '../utils/selectIds'
import { selectDashboard } from './selectDashboard'

export const getExpired = createSelector(
  [selectDashboard, selectWorkspaceId],
  (dashboard, workspaceId) => {
    const workspace: Workspace | null =
      dashboard.find((w) => w.id === workspaceId) || null

    return Boolean(workspace?.expired)
  }
)
